// extracted by mini-css-extract-plugin
module.exports = {"row":"stats_row__VIqGC","group":"stats_group__uRZAY","total":"stats_total__BZb_n","overrides":"stats_overrides__JpBo1"};